var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 70,
    viewBox: "0 0 91 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9531 66.9738C39.6434 60.5039 44.8743 59.0299 49.4101 58.963C59.9747 58.8072 66.757 70.0001 66.757 70.0001H90.3551C90.3551 70.0001 72.9551 46.7983 55.9068 46.7983C47.8976 46.7983 39.9656 51.9195 33.9531 66.9738Z",
    fill: "url(#paint0_linear_679_8801)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 69.9999H28.9349C42.8349 23.2624 73.8973 48.7848 73.8973 48.7848C64.0014 36.7451 54.3251 32.2671 45.405 32.2671C19.5145 32.2671 0 69.9999 0 69.9999Z",
    fill: "url(#paint1_linear_679_8801)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3477 37.2947C48.3916 17.5827 65.3236 34.9992 65.3236 34.9992L43.5498 0L20.3479 37.2947H20.3477Z",
    fill: "url(#paint2_linear_679_8801)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_679_8801",
    x1: 33.9531,
    y1: 58.3992,
    x2: 90.3565,
    y2: 58.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95C12B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14693C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_679_8801",
    x1: 0.000458324,
    y1: 54.7685,
    x2: 73.8978,
    y2: 54.7685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B231D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_679_8801",
    x1: 20.3486,
    y1: 18.6469,
    x2: 65.3232,
    y2: 18.6469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvg);
export default __webpack_public_path__ + "static/media/logo-svg.f18b9151719b20d76028ffd39d1293bc.svg";
export { ForwardRef as ReactComponent };